import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import SecureLS from "secure-ls";
import dayjs from "dayjs";

const ls = new SecureLS({ encodingType: "aes" });

const HandleDeleteItem = ({ item, onClose, onDeleteConfirm }) => {
  const handleConfirmDelete = () => {
    const storedInventory = ls.get("localDB_inventory") || { items: [] };
    const updatedInventory = storedInventory.items.filter(
      (inventoryItem) => inventoryItem !== item
    );

    const storedDeleted = ls.get("localDB_deleted") || [];
    ls.set("localDB_deleted", [...storedDeleted, item]);

    storedInventory.items = updatedInventory;
    ls.set("localDB_inventory", storedInventory);

    const newLog = {
      name: item.name,
      deliveryDate: item.deliveryDate,
      expiryDate: item.expiryDate,
      dateModified: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      action: "Deleted",
    };
    storedInventory.history = [...(storedInventory.history || []), newLog];
    ls.set("localDB_inventory", storedInventory);

    onDeleteConfirm();
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth>
      <DialogTitle>Delete Inventory Item</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete <strong>{item.name}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirmDelete} color="primary">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HandleDeleteItem;
